export default __webpack_public_path__ + "static/media/backdrop.4659d719.png";